import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { CapabilityBar } from './components/CapabilityBar';
import { BusinessUnits } from './components/BusinessUnits';
import { NationwideSection } from './components/NationwideSection';
import { PortfolioGrid } from './components/PortfolioGrid';
import { LeadCaptureForm } from './components/LeadCaptureForm';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-bone font-sans selection:bg-gold/30 selection:text-espresso" data-id="element-0" data-mp="2mnnefyugq1yn">
      <Navbar data-id="element-1" data-mp="31c1ksjr388jy" />
      <main data-id="element-2" data-mp="31cjou2jzrr2f">
        <HeroSection data-id="element-3" data-mp="2wka18t6cn33b" />
        <CapabilityBar data-id="element-4" data-mp="2wjqgl4pbe0ll" />
        <BusinessUnits data-id="element-5" data-mp="2wiferaffj2x4" />
        <NationwideSection data-id="element-6" data-mp="2whxabqim5ie4" />
        <PortfolioGrid data-id="element-7" data-mp="28u5ysp4wd9dw" />
        <LeadCaptureForm data-id="element-8" data-mp="28te21azkd5m1" />
      </main>
      <Footer data-id="element-9" data-mp="28sbcb6dz997p" />
      <WhatsAppButton data-id="element-10" data-mp="28s31dk1f0dz5" />
    </div>;
}